export const MY_TASK_REQUEST = "myTask/myTaskRequest";
export const MY_TASK_SUCCESS = "myTask/myTaskSuccess";
export const MY_TASK_ERROR = "myTask/myTaskError";